import IconBedBig from '@icons/BedBig'
import ShareButton from 'react-share/lib/ShareButton'
import IconCarBig from '@icons/CarBig'
import IconBathBig from '@icons/BathBig'
import * as S from './KeyDetails.styled'

const ICONS = {
  bedroom: <IconBedBig />,
  bathroom: <IconBathBig />,
  garage: <IconCarBig />,
}

const KeyDetails = ({
  listing,
  isGalleryView,
  showShareButton = true,
  offmarketUnlocked,
}) => {
  const areaUnits = {
    'squaremeter': <>m<sup>2</sup></>,
    'acre': ' acres',
    'hectare': ' hectares'
  }

  const normalizedUnit = listing.area_unit?.toLowerCase()?.replace(/\s+/g, '')
  const displayUnit = areaUnits[normalizedUnit] || null

  return (
    <>
      <S.KeyDetails isGalleryView={isGalleryView}>
        {listing.category && (
          <S.ListingCategory>{listing.category}</S.ListingCategory>
        )}
        {listing.features.map((feature, key) => (
          <S.KeyDetail key={`feature-${key}`}>
            <S.KeyDetailValue>{feature.label}</S.KeyDetailValue>
            {ICONS[feature.icon]}
          </S.KeyDetail>
        ))}
        {listing.area && (
          <S.KeyDetail key='area' area>
            <S.KeyDetailValue>
              {parseFloat(listing.area)} {displayUnit} (approx)
            </S.KeyDetailValue>
          </S.KeyDetail>
        )}
        {showShareButton && (
          <ShareButton
            listing={listing}
            offmarketUnlocked={offmarketUnlocked}
            shareInfo={{
              url: listing.url,
              quote: listing.address + ' - ' + listing.headline,
              media: listing.image_url,
              image: listing.image_url,
              subject: 'Check out this property from Barry Plant',
            }}
          />
        )}
      </S.KeyDetails>
    </>
  )
}

export default KeyDetails
